var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveBus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_555_352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33102 3.99805V7.99632",
    stroke: "#0A0A0A",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9957 3.99805V7.99632",
    stroke: "#0A0A0A",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33276 7.99609H14.3938",
    stroke: "#0A0A0A",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9948 11.9946H13.994C13.994 11.9946 14.3272 10.8618 14.5271 10.1287C14.5937 9.86218 14.6603 9.59563 14.6603 9.32908C14.6603 9.06253 14.5937 8.79598 14.5271 8.52943L13.5941 5.19753C13.3942 4.53115 12.7278 3.99805 11.9948 3.99805H2.66552C2.31205 3.99805 1.97306 4.13846 1.72312 4.3884C1.47318 4.63834 1.33276 4.97734 1.33276 5.33081V11.9946H3.3319",
    stroke: "#0A0A0A",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66467 13.3276C5.40073 13.3276 5.99743 12.7309 5.99743 11.9949C5.99743 11.2588 5.40073 10.6621 4.66467 10.6621C3.92861 10.6621 3.33191 11.2588 3.33191 11.9949C3.33191 12.7309 3.92861 13.3276 4.66467 13.3276Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99741 11.9941H9.3293",
    stroke: "#0A0A0A",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6621 13.3276C11.3981 13.3276 11.9948 12.7309 11.9948 11.9949C11.9948 11.2588 11.3981 10.6621 10.6621 10.6621C9.92601 10.6621 9.32932 11.2588 9.32932 11.9949C9.32932 12.7309 9.92601 13.3276 10.6621 13.3276Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_555_352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9931,
    height: 15.9931,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveBus);
export default __webpack_public_path__ + "static/media/Active_bus.f8278b6b26ef291836a6f0356f1089b0.svg";
export { ForwardRef as ReactComponent };